<template>
  <div class="newCloudPhone pointer">
    <div class="titleBox">
      <NavBar title="新增云手机"></NavBar>
      <div class="modelTabs">
        <div
          :class="['tab', item.label, modelActive == index ? 'checkedTab' : '']"
          v-for="(item, index) in modelTabsList"
          :key="item.label"
          @click="onClickModel(index)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>

    <v-touch
      v-on:swipeleft="swiperleft"
      v-on:swiperight="swiperright"
      class="wrapper solveBfc contentBox"
      :style="{}"
    >
      <div class="packageSelection">
        <SetMeal
          :modelActive="modelActive"
          :versionList="versionList"
          :supplierActive="supplierActive"
          :versionsActive="versionsActive"
          :commodityActive="commodityActive"
          :intCount="intCount"
          :showAll="showAll"
          @supplierChange="supplierChange"
          @versionsChange="versionsChange"
          @commodityChange="commodityChange"
          @handleMore="handleMore"
        ></SetMeal>
      </div>
      <div class="PayTypeAmountBox solveBfc">
        <PayTypeAmount
          :combo="
            packageListItems(
              versionList[supplierActive].productVersionVos[versionsActive]
                .packageList,
              commodityActive
            )
          "
          :count.sync="count"
          :payType="payType"
          @handleChange="handleStepperChange"
          @handlePayTypeChange="handlePayTypeChange"
          :isStepper="false"
        ></PayTypeAmount>
      </div>
      <div class="agreementBox">
        <img class="hint2" src="@/assets/icons/hint2.png" alt="" />
        <div>在购买前请阅读</div>
        <div class="hyperlink" @click="toAgreement">《会员服务协议》</div>
      </div>
    </v-touch>
    <div class="baseBox">
      <!-- <div class="totalPricesBox">
        <div class="name">订单价</div>
        <div class="salePrice">
          <div class="span1">¥</div>
          <div class="span2">{{ (combo.salePrice * count).toFixed(2) }}</div>
        </div>
      </div> -->
      <van-button class="confirmPayment" @click="orderAffirmShow = true"
        >立即购买</van-button
      >
    </div>
    <van-action-sheet
      class="orderAffirmPopup pcPopup"
      v-model="orderAffirmShow"
    >
      <div class="content">
        <div class="card_1">
          <div class="titleBox">
            <div class="titleName">订单确认</div>
            <div class="close" @click="orderAffirmShow = false">
              <img src="@/assets/icons/popupClose.png" alt="" />
            </div>
          </div>
        </div>
        <div class="slideContent">
          <div class="card_2">
            <div class="card_2_left">{{ handleCombo(combo).packageName }}</div>
            <div class="card_2_right">
              <span class="sp1">{{
                ` ¥ ${handleCombo(combo).originPrice.toFixed(2)} /台`
              }}</span>
              <span class="sp2">{{
                ` 到手价 ¥ ${handleCombo(combo).salePrice.toFixed(2)} /台`
              }}</span>
            </div>
          </div>
          <div class="card_3" v-if="combo.batchPackageList.length > 0">
            <div class="card_3_top">
              <div>阶梯单价</div>
              <div>数量区间</div>
            </div>
            <div class="card_3_bottom">
              <div
                v-for="(item, index) in combo.batchPackageList"
                :key="index"
                :class="[
                  'card_3_bottom_item',
                  count >= item.minCount && count <= item.maxCount
                    ? 'sectionActive'
                    : '',
                ]"
                @click="handleBatchPackage(item.minCount, item.maxCount)"
              >
                <div class="priceBox">
                  <div class="salePrice">
                    <div class="span1">¥</div>
                    <div class="span2">{{ item.salePrice.toFixed(2) }}</div>
                  </div>
                  <div class="avgPrice">
                    {{ ` ¥ ${item.avgPrice.toFixed(2)} /天` }}
                  </div>
                </div>
                <div class="sectionBox">
                  {{ `${item.minCount} ≤ 购买数量 ≤ ${item.maxCount}` }}
                </div>
              </div>
            </div>
          </div>
          <div class="card_4">
            <PayTypeAmount
              :combo="
                packageListItems(
                  versionList[supplierActive].productVersionVos[versionsActive]
                    .packageList,
                  commodityActive
                )
              "
              :count.sync="count"
              :payType="payType"
              @handleChange="handleStepperChange"
              @handlePayTypeChange="handlePayTypeChange"
              :isStepper="true"
            ></PayTypeAmount>
          </div>
        </div>
        <div class="baseContent">
          <div class="base_discounts">
            <div class="base_left">共计{{ count }}台</div>
            <div class="base_left">
              已优惠：{{
                (
                  (handleCombo(combo).originPrice -
                    handleCombo(combo).salePrice) *
                  count
                ).toFixed(2)
              }}
            </div>
          </div>
          <div class="base_actuallyPaid" @click="getordercreate">
            确认支付 ¥{{ (handleCombo(combo).salePrice * count).toFixed(2) }}
          </div>
        </div>
      </div>
    </van-action-sheet>
    <van-action-sheet
      :class="['infoRderNoPopup', 'pcPopup', showDialog ? 'isShow' : '']"
      v-model="rderNoResultShow"
      :close-on-click-overlay="false"
    >
      <div class="content">
        <div class="close" @click="payClose">
          <img src="@/assets/icons/popupClose.png" alt="" />
        </div>
        <img
          v-if="pay_obj.orderStatus == 'SUCCESS'"
          class="payImg"
          src="@/assets/imgs/paySucceed.png"
          alt=""
        />
        <img v-else class="payImg" src="@/assets/imgs/payFail.png" alt="" />
        <div class="totalAmount">
          <span>{{
            pay_obj.orderStatus == "SUCCESS" ? "支付成功" : "支付失败"
          }}</span>
          <span> ¥ {{ pay_obj.totalAmount.toFixed(2) }}</span>
        </div>
        <div class="atPayType">{{ atPayType }}支付</div>
        <div class="toPlay" @click="payFinish">
          {{
            pay_obj.orderStatus == "SUCCESS"
              ? getInstanceStatus(pay_obj.instanceStatus)
              : "重新购买"
          }}
        </div>
      </div>
    </van-action-sheet>
    <generalConfirm
      :showDialog.sync="showDialog"
      :content="contentDialog"
      @affirm="confirmModel"
    ></generalConfirm>
  </div>
</template>
  
  <script>
import NavBar from "@/components/NavBar.vue";
import SetMeal from "@/components/buy/SetMeal.vue";
import PayTypeAmount from "@/components/buy/PayTypeAmount.vue";
import {
  packageversionListV2,
  ordercreate,
  infoRderNo,
  getopenId,
} from "@/api/buy";
import { sysConfigByConfigKey } from "@/api/index.js";
import generalConfirm from "@/components/publicDialog/generalConfirm.vue";
import Cookies from "js-cookie";
import { Toast } from "vant";
export default {
  name: "NewCloudPhone",
  components: {
    NavBar,
    SetMeal,
    PayTypeAmount,
    generalConfirm,
  },
  data() {
    return {
      modelActive: 0,
      modelTabsList: [
        // { label: "VIP", value: "0", vipCode: "VIP1" },
        // { label: "GVIP", value: "1", vipCode: "VIP2" },
        // { label: "KVIP", value: "2", vipCode: "VIP3" },
        // { label: "XVIP", value: "3", vipCode: "VIP4" },
        // 定制
        // { label: "GVIP", value: "0", vipCode: "VIP2" },
        { label: "XVIP", value: "0", vipCode: "XVIP10" },
        // { label: "番茄小说定制版", value: "1", vipCode: "GVIP-FQXSDZB" },
      ],
      versionList: [{ productVersionVos: [{ packageList: [] }] }],
      supplierList: [],
      // 厂商
      supplierActive: 0,
      //   版本
      versionsActive: 0,
      // 商品
      commodityActive: 0,
      // 查看更多
      intCount: 4,
      showAll: false,
      count: 1,
      payType: 5,
      combo: {
        salePrice: 0,
        originPrice: 0,
        avgPrice: 0,
        batchPackageList: [],
      },
      orderAffirmShow: false,
      rderNoResultShow: false,
      atPayType: "微信",
      pay_obj: { totalAmount: 0 },
      instanceStatusOptional: [
        {
          label: "云手机分配中，请稍候!",
          value: 0,
        },
        { label: "查看新购云手机", value: 1 },
        {
          label: "云手机分配异常，点击联系客服",
          value: 2,
        },
      ],
      contentDialog:
        "云手机正在交付中，关闭弹窗将无法准确获取结果，是否继续退出?",
      showDialog: false,
      openld: null,
    };
  },
  mounted() {
    this.getPackageversionList();
    this.getInfoRderNo();
    // 本地存储避免多次请求code报错
    let openIdCookies = Cookies.get("openid");
    if (!openIdCookies || openIdCookies == 0) {
      this.getCode();
    } else {
      this.openld = openIdCookies;
    }
  },
  beforeDestroy() {},

  methods: {
    // 获取code
    async getCode() {
      var str = this.$route.query.code;
      if (str) {
        let data = {
          code: str,
        };
        // 走后端接口(把code传给后台，让后台根据code获取openID与用户信息) 通过code 获取openid
        await getopenId(data).then((res) => {
          if (res.code == 200) {
            this.openld = res.msg;
            Cookies.set("openid", res.msg);
          } else {
            Toast("获取失败！");
          }
        });
      } else {
        if (
          typeof WeixinJSBridge === "object" &&
          typeof WeixinJSBridge.invoke === "function"
        ) {
          var appid = "wx909fcb382f6004ca";
          var redirect_uri = window.location.href;
          var newRedirect = encodeURIComponent(redirect_uri); // 此处需要将你的回调页面进行转码，此方法直接使用
          location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            appid +
            "&redirect_uri=" +
            newRedirect +
            "&response_type=code&scope=snsapi_userinfo&state=333&connect_redirect=1#wechat_redirect";
        }
      }
    },
    // 获取云手机套餐
    async getPackageversionList() {
      let that = this;
      let data = {
        vipCode: this.getVipCode(this.modelActive),
        deviceVersionCode: null,
        renewId: null,
        channelCode: null,
      };
      this.$common.gteReportPage(
        "支付页",
        "product",
        this.getVipCode(this.modelActive)
      );
      await packageversionListV2(data).then((res) => {
        if (res.code == 200) {
          that.versionList = customSort(res.data);
          function customSort(arr) {
            // 定义排序优先级
            const priority = {
              huawei: 1,
              intelligent: 2,
              baidu: 3,
              huoshan: 4,
            };
            // 厂商排序
            arr.sort((a, b) => {
              return priority[a.supplier] - priority[b.supplier];
            });
            arr.forEach((item) => {
              item.productVersionVos.forEach((list) => {
                list.packageList.forEach((code, index) => {
                  code.overallMminCount = code.minCount;
                  // 阶梯价格排序
                  code.batchPackageList.sort((a, b) => {
                    return a.minCount - b.minCount;
                  });
                  // 阶梯价格最小价格
                  if (code.batchPackageList.length > 0) {
                    let findItem =
                      code.batchPackageList[code.batchPackageList.length - 1];
                    findItem.batchPackageList = code.batchPackageList;
                    findItem.overallMminCount = code.overallMminCount;
                    that.$set(list.packageList, index, findItem);
                  }
                });
              });
            });
            return arr;
          }
          this.valuationCount();
        }
      });
    },
    swiperleft: function () {
      //左划
      if (this.modelActive < 1) {
        this.onClickModel(this.modelActive + 1);
      }
    },
    swiperright: function () {
      //右滑
      if (this.modelActive >= 1) {
        this.onClickModel(this.modelActive - 1);
      }
    },
    onClickModel(index) {
      if (this.modelActive != index) {
        this.modelActive = index;
        this.supplierActive = 0;
        this.commodityActive = 0;
        this.versionsActive = 0;
        this.getPackageversionList();
      }
    },
    supplierChange(index) {
      if (this.supplierActive != index) {
        this.supplierActive = index;
        this.commodityActive = 0;
        this.versionsActive = 0;
        this.valuationCount();
      }
    },
    versionsChange(index) {
      if (this.versionsActive != index) {
        this.versionsActive = index;
        this.commodityActive = 0;
        this.valuationCount();
        this.$forceUpdate();
      }
    },
    commodityChange(index) {
      if (this.commodityActive != index) {
        this.commodityActive = index;
        this.valuationCount();
      }
    },
    handleMore(type) {
      if (type == 0) {
        this.showAll = true;
        this.commodityActive = 0;
        this.valuationCount();
      }
      if (type == 1) {
        this.showAll = false;
        this.commodityActive = 0;
        this.valuationCount();
      }
    },
    handleStepperChange(count) {
      this.count = count;
      // this.threeShiftTwo();
    },
    handlePayTypeChange(type) {
      if (this.payType != type) {
        this.payType = type;
      }
    },
    threeShiftTwo() {
      let commodityNum = this.showAll
        ? this.intCount + this.commodityActive
        : this.commodityActive;
      let data =
        this.versionList[this.supplierActive].productVersionVos[
          this.versionsActive
        ].packageList[commodityNum];
      if (data.batchPackageList.length > 0) {
        if (this.count < data.minCount || this.count > data.maxCount) {
          let findItem = data.batchPackageList.find(
            (item) => this.count >= item.minCount && this.count <= item.maxCount
          );
          if (findItem) {
            findItem.batchPackageList = data.batchPackageList;
            findItem.overallMminCount = data.overallMminCount;
            this.$set(
              this.versionList[this.supplierActive].productVersionVos[
                this.versionsActive
              ].packageList,
              commodityNum,
              findItem
            );
          }
        }
      }
    },
    valuationCount() {
      let commodityNum = this.showAll
        ? this.intCount + this.commodityActive
        : this.commodityActive;
      let data =
        this.versionList[this.supplierActive].productVersionVos[
          this.versionsActive
        ].packageList[commodityNum];
      this.count = data.overallMminCount;
    },
    // 创建订单并拉起支付
    getordercreate() {
      let that = this;
      let _payType = that.payType;
      if (that.payType != 6) {
        const isWeixinBrowser = /micromessenger/i.test(navigator.userAgent);
        if (isWeixinBrowser) {
          _payType = 7;
        } else {
          _payType = 5;
        }
      }
      let _combo = this.handleCombo(this.combo);
      if (_combo.id) {
        let data = {
          packageId: _combo.id,
          totalAmount: (_combo.salePrice * that.count).toFixed(2),
          count: that.count,
          payType: _payType,
          renewIds: null,
          skipUrl: process.env.VUE_APP_LOOK_URL + "/newCloudPhone",
          openId: that.openld,
        };
        ordercreate(data).then((res) => {
          if (res.code == 200) {
            if (_payType == 6) {
              let div = document.querySelector("#payDiv");
              if (!div) {
                div = document.createElement("div");
                div.id = "payDiv";
                document.body.appendChild(div);
              }
              div.innerHTML = res.data.payUrl;
              document.forms[0].submit();
            }
            if (_payType == 5) {
              location.href =
                res.data.payUrl +
                `&redirect_url=${process.env.VUE_APP_LOOK_URL}/newCloudPhone?payType=${res.data.orderNo}`;
            }
            if (_payType == 7) {
              that.onBridgeReady(res.data);
            }
          }
        });
      } else {
        Toast("请先选择套餐!");
      }
    },
    // 微信支付专用
    onBridgeReady(params) {
      let data = {
        appId: "wx909fcb382f6004ca", //公众号名称，由商户传入
        timeStamp: params.timeStamp, //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: params.nonce, //支付签名随机串，不长于 32 位
        package: "prepay_id=" + params.prepayId, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: "RSA", //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: params.sign, //支付签名
        notify_url: "https://www.weixin.qq.com/wxpay/pay.php",
        amount: {
          total: params.totalAmount,
          currency: "CNY",
        },
      };
      WeixinJSBridge.invoke("getBrandWCPayRequest", data, function (res) {
        if (res.err_msg === "get_brand_wcpay_request:ok") {
          // this.$router.push({ path: "/resultpayment" });
          window.location.href = `${process.env.VUE_APP_LOOK_URL}/newCloudPhone?payType=${params.orderNo}`;
        } else if (res.err_msg === "get_brand_wcpay_request:fail") {
          Toast(res.err_msg);
        }
      });
    },
    handleCombo(list) {
      let findItem = list.batchPackageList.find(
        (item) => this.count >= item.minCount && this.count <= item.maxCount
      );
      if (findItem) {
        return findItem;
      } else {
        return list;
      }
    },
    getInfoRderNo() {
      let parameters = null;
      if (this.$route.query.out_trade_no) {
        parameters = this.$route.query.out_trade_no;
        this.atPayType = "支付宝";
      } else {
        parameters = this.$route.query.payType;
        this.atPayType = "微信";
      }
      if (!parameters) {
        return;
      }
      this.num++;
      infoRderNo(parameters).then((res) => {
        if (res.code == 200) {
          if (res.data.orderStatus == "SUCCESS") {
            this.pay_obj = res.data;
            if (res.data.instanceStatus == 0) {
              this.setTime = setTimeout(() => {
                this.getInfoRderNo();
              }, 1000);
            }
            this.rderNoResultShow = true;
          } else {
            this.setTime = setTimeout(() => {
              if (this.num <= 3) {
                this.getInfoRderNo();
              } else {
                this.pay_obj = res.data;
                this.rderNoResultShow = true;
              }
            }, 1000);
          }
        }
      });
    },
    payFinish() {
      if (
        this.pay_obj.instanceStatus == 0 &&
        this.pay_obj.orderStatus == "SUCCESS"
      ) {
        this.showDialog = true;
      } else if (this.pay_obj.instanceStatus == 2) {
        this.$router.push("/");
        sysConfigByConfigKey({ configKey: "wx_kf_url" }).then((res) => {
          if (res.code == 200) {
            window.location.href = `https://work.weixin.qq.com/kfid/${res.data}`;
          }
        });
      } else {
        this.$router.push("/");
      }
    },
    payClose() {
      if (
        this.pay_obj.instanceStatus == 0 &&
        this.pay_obj.orderStatus == "SUCCESS"
      ) {
        this.showDialog = true;
      } else {
        this.$router.push("/");
      }
    },
    confirmModel() {
      this.$router.push("/");
    },
    toAgreement() {
      location.href = "http://static.aixunliu.com/app/vip.html";
    },
    handleBatchPackage(minCount, maxCount) {
      if (!(this.count >= minCount && this.count <= maxCount)) {
        this.count = minCount;
      }
    },
  },
  computed: {
    getVipCode: {
      get() {
        return function (status) {
          let item = this.modelTabsList.find((item) => item.value == status);
          if (item) {
            return item.vipCode;
          }
        };
      },
    },
    getInstanceStatus: {
      get() {
        return function (status) {
          let item = this.instanceStatusOptional.find(
            (item) => item.value == status
          );
          if (item) {
            return item.label;
          }
        };
      },
    },
    packageListItems: {
      get() {
        return function (list, index) {
          let data = this.showAll ? list[this.intCount + index] : list[index];
          if (data) {
            // this.count = data.minCount;
            this.combo = data;
          }
          return data;
        };
      },
    },
  },
};
</script>
  
  <style lang="less" scoped>
.newCloudPhone {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.titleBox {
  padding: 0 10px;
  .modelTabs {
    width: 100%;
    height: 38px;
    position: relative;
    margin-top: 4px;
    .tab {
      position: absolute;
      // width: 96px;
      width: 50%;
      height: 38px;
      line-height: 38px;
      background: #f0edfe;
      border-radius: 10px 10px 0px 0px;
      border: 1px solid #ffffff;
      font-weight: bold;
      font-size: 17px;
      color: #bdb5ff;
    }
    .VIP {
      left: 0;
      z-index: 4;
    }
    // .SVIP{
    //   left: 0;
    //   z-index: 4;
    // }
    .番茄小说定制版{
      // left: 24%;
      right: 0;
      z-index: 3;
    }
    .GVIP {
      // left: 24%;
      right: 0;
      z-index: 3;
    }
    .KVIP {
      right: 24%;
      z-index: 2;
    }
    .XVIP {
      right: 0;
      z-index: 1;
    }
    .checkedTab {
      // width: 101px;
      // width: 55%;
      width: 100%;
      height: 42px;
      line-height: 42px;
      font-size: 19px;
      color: #886df3;
      background: linear-gradient(180deg, #e6e6ff 0%, #ffffff 100%);
      // margin-top: -4px;
      z-index: 99;
    }
  }
}

.contentBox {
  font-family: MiSans, MiSans;
  padding: 0 10px 12px 10px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: pan-y !important;
  scrollbar-width: none;
  .wrapper {
    width: 100%;
    height: 100%;
  }
  .packageSelection {
    width: 100%;
  }
  .PayTypeAmountBox {
    margin-top: 8px;
  }
  .agreementBox {
    font-weight: 500;
    font-size: 13px;
    color: #a9adb6;
    display: flex;
    align-items: center;
    padding: 17px 0 22px 0;
    .hint2 {
      width: 17px;
      height: 17px;
      margin-right: 8px;
    }
    .hyperlink {
      color: #a092eb;
    }
  }
}
.baseBox {
  width: 100%;
  height: 56px;
  background: #fff;
  border: 1px solid #f4f6fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 13px;
  .totalPricesBox {
    display: flex;
    align-items: center;
    .salePrice {
      display: flex;
      align-items: baseline;
      margin-left: 8px;
      .span1 {
        font-size: 13px;
        font-weight: 500;
        color: #8572eb;
        margin-right: 4px;
      }
      .span2 {
        font-size: 21px;
        font-weight: Bold;
        color: #8572eb;
      }
    }
  }
  .confirmPayment {
    width: 100%;
    height: 42px;
    background: #8572eb;
    border-radius: 21px;
    font-weight: 600;
    font-size: 15px;
    color: #ffffff;
  }
}
.orderAffirmPopup {
  max-height: 100%;
  .content {
    padding: 0 10px;
    background: #f5f7fb;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    max-height: 600px;
  }
  .card_1 {
    padding: 25px 0 13px 0;
    .titleBox {
      display: flex;
      justify-content: center;
      position: relative;
      padding: 0;
      .titleName {
        font-weight: 600;
        font-size: 17px;
        color: #222222;
      }
      .close {
        width: 25px;
        height: 25px;
        position: absolute;
        right: 11px;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 17px;
          height: 17px;
        }
      }
    }
  }
  .slideContent {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    touch-action: manipulation;
    scrollbar-width: none;
    .card_2 {
      width: 100%;
      height: 61px;
      background: #fff;
      border-radius: 13px;
      margin-top: 12px;
      padding: 0 17px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card_2_left {
        font-weight: 600;
        font-size: 15px;
        color: #505465;
      }
      .card_2_right {
        .sp1 {
          font-weight: 500;
          font-size: 13px;
          color: #a9adb6;
          margin-right: 8px;
          text-decoration: line-through;
        }
        .sp2 {
          font-weight: 500;
          font-size: 15px;
          color: #8572eb;
        }
      }
    }
    .card_3 {
      margin-top: 12px;
      .card_3_top {
        width: 354px;
        height: 46px;
        border-radius: 13px 13px 0 0px;
        background: #fff;
        padding: 0 17px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 500;
        font-size: 13px;
        color: #a9adb6;
      }
      .card_3_bottom {
        width: 100%;
        background: #ffffff;
        .card_3_bottom_item {
          width: 100%;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 17px;
          .priceBox {
            display: flex;
            .salePrice {
              display: flex;
              align-items: baseline;
              margin-right: 10px;
              .span1 {
                font-weight: 600;
                font-size: 13px;
                color: #505465;
                margin-right: 2px;
              }
              .span2 {
                font-weight: 600;
                font-size: 17px;
                color: #505465;
              }
            }
            .avgPrice {
              font-weight: 500;
              font-size: 10px;
              color: #67686e;
            }
          }
          .sectionBox {
            font-weight: 500;
            font-size: 13px;
            color: #67686e;
          }
        }
        .sectionActive {
          background: #f0edfe;
          .priceBox {
            .salePrice {
              .span1 {
                color: #8572eb;
              }
              .span2 {
                color: #8572eb;
              }
            }
            .avgPrice {
              color: #a092eb;
            }
          }
          .sectionBox {
            color: #a092eb;
          }
        }
      }
    }
    .card_4 {
      margin-top: 12px;
    }
  }
  .baseContent {
    padding: 25px 21px 31px 21px;
    .base_discounts {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;
      font-size: 13px;
      color: #505465;
    }
    .base_actuallyPaid {
      width: 100%;
      height: 42px;
      line-height: 42px;
      background: #886df3;
      border-radius: 267px;
      font-weight: 500;
      font-size: 15px;
      color: #fff;
      margin-top: 17px;
    }
  }
}
.isShow {
  z-index: 0 !important;
}
.infoRderNoPopup {
  .content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 31px;
    .close {
      width: 25px;
      height: 25px;
      position: absolute;
      right: 17px;
      top: 21px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 17px;
        height: 17px;
      }
    }
    .payImg {
      margin: 50px 0 31px;
      width: 92px;
      height: 92px;
    }
    .totalAmount {
      font-weight: 600;
      font-size: 19px;
      color: #505465;
    }
    .atPayType {
      font-weight: 500;
      font-size: 15px;
      color: #a9adb6;
      margin: 16px 0 25px 0;
    }
    .toPlay {
      width: 333px;
      height: 42px;
      line-height: 42px;
      background: #886df3;
      border-radius: 267px;
      font-weight: 500;
      font-size: 15px;
      color: #ffffff;
    }
  }
}
</style>